import Icon from '../Icon/Icon';
import RichText from '../RichText/RichText';
import Stack from '../Stack/Stack';
import styles from './FormOptInInfo.module.scss';

const FormOptInInfo = () => {
  return (
    <Stack flexDirection="row" gap="1rem">
      <Stack.Item>
        <Icon
          className={styles.icon}
          variant="user/information"
          size="iconSize24"
        />
      </Stack.Item>
      <Stack.Item>
        <RichText className={styles.text}>
          Informationen gemäß Art. 13 DSGVO über die Verarbeitung Ihrer
          personenbezogenen Daten finden Sie in unseren{' '}
          <a
            target="_blank"
            rel="noreferrer noopener"
            href="https://www.enercity-netz.de/unternehmen/fakten/datenschutz/index.html"
          >
            Datenschutzinformationen
          </a>
          .
        </RichText>
      </Stack.Item>
    </Stack>
  );
};

export default FormOptInInfo;
